const config = {
  apiGateway: {
    REGION: 'ap-southeast-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://5a4v53g87g.execute-api.ap-southeast-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://6jc6g706ff.execute-api.ap-southeast-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://q554hzcj82.execute-api.ap-southeast-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.ozminerals.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.ozminerals.forwoodsafety.com',
    WEBSOCKET: 'wss://wg3taxg1u2.execute-api.ap-southeast-2.amazonaws.com/prod'
  },
};

export default config;